import { format } from 'date-fns';

export const getServerFormValues = (job, previousForm) => ({
  assignedToId: job.assignedTo?.id ? String(job.assignedTo.id) : '',
  serviceTypeId: job.serviceType?.id || '',
  status: job.status || 'PENDING',
  notes: job.notes || '',
  hasDateOverride: job.hasDateOverride || false,
  hasTimeOverride: job.hasTimeOverride || false,
  hasServiceTypeOverride: job.hasServiceTypeOverride || false,
  scheduledDate: format(new Date(job.scheduledDate), 'yyyy-MM-dd'),
  startTime: job.startTime || previousForm.startTime || '',
  payout: job.payout !== null && job.payout !== undefined ? String(job.payout) : '',
  billedAmount:
    job.billedAmount !== null && job.billedAmount !== undefined
      ? String(job.billedAmount)
      : '',
});

export const mergeServerJobIntoForm = (previousForm, job, dirtyFields) => {
  const serverValues = getServerFormValues(job, previousForm);

  return Object.entries(serverValues).reduce(
    (nextForm, [field, value]) => {
      if (!dirtyFields.has(field)) {
        nextForm[field] = value;
      }
      return nextForm;
    },
    { ...previousForm },
  );
};
